"use strict";
/*
 * ATTENTION: An "eval-source-map" devtool has been used.
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file with attached SourceMaps in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
(self["webpackChunkmondaine_new_theme"] = self["webpackChunkmondaine_new_theme"] || []).push([["collection"],{

/***/ "./src/source/collection/index.ts":
/*!****************************************!*\
  !*** ./src/source/collection/index.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

eval("\n\nObject.defineProperty(exports, \"__esModule\", ({\n  value: true\n}));\n__webpack_require__(/*! ./styles */ \"./src/source/collection/styles/index.ts\");//# sourceURL=[module]\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiLi9zcmMvc291cmNlL2NvbGxlY3Rpb24vaW5kZXgudHMuanMiLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSIsInNvdXJjZXMiOlsid2VicGFjazovL21vbmRhaW5lLW5ldy10aGVtZS8uL3NyYy9zb3VyY2UvY29sbGVjdGlvbi9pbmRleC50cz80YzYxIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCAnLi9zdHlsZXMnOyJdLCJuYW1lcyI6W10sInNvdXJjZVJvb3QiOiIifQ==\n//# sourceURL=webpack-internal:///./src/source/collection/index.ts\n");

/***/ }),

/***/ "./src/source/collection/styles/index.ts":
/*!***********************************************!*\
  !*** ./src/source/collection/styles/index.ts ***!
  \***********************************************/
/***/ (() => {

eval("\n\n// import all .scss files here...//# sourceURL=[module]\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiLi9zcmMvc291cmNlL2NvbGxlY3Rpb24vc3R5bGVzL2luZGV4LnRzLmpzIiwibWFwcGluZ3MiOiI7O0FBQUEiLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly9tb25kYWluZS1uZXctdGhlbWUvLi9zcmMvc291cmNlL2NvbGxlY3Rpb24vc3R5bGVzL2luZGV4LnRzPzdhNzIiXSwic291cmNlc0NvbnRlbnQiOlsiLy8gaW1wb3J0IGFsbCAuc2NzcyBmaWxlcyBoZXJlLi4uIl0sIm5hbWVzIjpbXSwic291cmNlUm9vdCI6IiJ9\n//# sourceURL=webpack-internal:///./src/source/collection/styles/index.ts\n");

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__("./src/source/collection/index.ts"));
/******/ }
]);